import React from 'react';
import './Navigation.css';

const Navigation = () => {
  const handleClick = (e, hash) => {
    e.preventDefault();
    window.location.hash = hash;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="main-nav">
      <div className="nav-container">
        <div className="nav-brand">
          <img src="/favicon-32x32.png" alt="Logo" className="brand-icon-img" />
          <div className="brand-text">
            <h2>Kenyan Financial Hub</h2>
          </div>
        </div>
        <div className="nav-links">
          <a href="#home" className="nav-link" onClick={(e) => handleClick(e, 'home')}>Home</a>
          <a href="#about" className="nav-link" onClick={(e) => handleClick(e, 'about')}>About</a>
          <a href="#contact" className="nav-link" onClick={(e) => handleClick(e, 'contact')}>Contact</a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
